export const InventoryFormOperator = Object.freeze({
	IsAnything: 0,
	Is: 1,
	IsNot: 2,
	Contains: 3,
	DoesNotContain: 4,
	IsBlank: 5,
	IsOneOf: 6,
	IsNotOneOf: 7,
	StartsWith: 8,
});

export const InventoryFormOperatorTypes = [
	{ value: InventoryFormOperator.IsAnything, text: 'Is anything (*)' },
	{ value: InventoryFormOperator.IsBlank, text: 'Is blank' },
	{ value: InventoryFormOperator.Is, text: 'Is (=)' },
	{ value: InventoryFormOperator.IsNot, text: 'Is not (≠)' },
	{ value: InventoryFormOperator.Contains, text: 'Contains' },
	{ value: InventoryFormOperator.DoesNotContain, text: 'Does not contain' },
	{ value: InventoryFormOperator.StartsWith, text: 'Starts with' },
	{
		value: InventoryFormOperator.IsOneOf,
		text: 'Is one of (e.g., x, y, z...)',
	},
	{
		value: InventoryFormOperator.IsNotOneOf,
		text: 'Is not one of (e.g., not x, y, z...)',
	},
];
